// extracted by mini-css-extract-plugin
export default {"quick":"DressesInfo_quick__wK86r","image":"DressesInfo_image__qtZ5K"};